import React from 'react'
import { SimpleSelect } from './SimpleSelect'
import { UserSelect } from './UserSelect'
import { UserMultiSelect } from './UserMultiSelect'
import type { SelectProps } from './types'

export const Select: React.FC<SelectProps> = (props) => {
  if ('variant' in props && props.variant === 'user') {
    return <UserSelect {...props} />
  }
  
  if ('variant' in props && props.variant === 'user-multi') {
    return <UserMultiSelect {...props} />
  }
  
  return <SimpleSelect {...props} />
}

export type { SelectOption, UserOption, SetorOption, AuthorizerOption, SelectProps, SimpleSelectProps, UserSelectProps, UserMultiSelectProps, SetorMultiSelectProps, SectorSelectProps, AuthorizerSelectProps } from './types'
export { UserMultiSelect } from './UserMultiSelect'
export { SectorSelect } from './SectorSelect'
export { SetorMultiSelect } from './SetorMultiSelect'
export { ProcessSelect } from './ProcessSelect'
export { UnifiedProcessSelector } from './UnifiedProcessSelector'
export { LocationSelect } from './LocationSelect'
export { AuthorizerSelect } from './AuthorizerSelect'
export { AuthorizerMultiSelect } from './AuthorizerMultiSelect'
export type { LocationOption, LocationSelectProps } from './LocationSelect'

export default Select